import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import BaseCheckbox from '@r1-frontend/ui-react/components/controls/baseCheckbox';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BlockContainer } from '@r1-frontend/ui-react/experimental/containers';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

import { toggleConnectAutoPayStatus } from '~/src/features/payments-abn/store/actionCreators';
import { TState } from '~/src/store';

/**
 * Форма подключения автоплатежа
 */
export const ConnectAutoPay = (): JSX.Element | null => {
    const isTablet = useMatchMediaByWidth(wideBreakpoints.mobile);

    const dispatch = useDispatch();

    const { isConnectAutoPay, isDisabled, showAutoPay } = useSelector((state: TState) => ({
        isConnectAutoPay: state.payment.paymentData.isConnectAutoPay,
        isDisabled: state.payment.method?.methodType === 'new-card' && !state.payment.isSaveCard,
        showAutoPay: state.auth.isAuth && !state.payment.method?.isAutoPayConnected,
    }), shallowEqual);

    const toggleConnectAutoPay = () => {
        dispatch(toggleConnectAutoPayStatus(!isConnectAutoPay));
    };

    if (!showAutoPay) {
        return null;
    }

    return (
        <BlockContainer
            rounder={{ $desktop: 32, $mobile: 16 }}
            indent={{ $desktop: [32, 24], $mobile: [24, 16] }}
        >
            <BaseCheckbox
                size={isTablet ? 'XS' : 'S'}
                checked={isConnectAutoPay}
                disabled={isDisabled}
                onChange={toggleConnectAutoPay}
            >
                Подключить автоплатёж
            </BaseCheckbox>
        </BlockContainer>
    );
};
